import { useQuery } from 'react-query';
import { UseFullCompanyOptions } from './useFullCompany.types';
import { queryFullCompany } from './useFullCompany.query';
import { FullCompany } from '../../../types/models/company/company.types';
import { PlanENT } from '../../../types/models/plans/plans.types';

export const GET_FULL_COMPANY_QUERY_KEY = 'GET_FULL_COMPANY';

export const useFullCompany = (companyId: number, options?: UseFullCompanyOptions) => {
  return useQuery<FullCompany & PlanENT, Error>(GET_FULL_COMPANY_QUERY_KEY, () => queryFullCompany(companyId), {
    ...options,
    retry: false,
    refetchOnWindowFocus: false,
  });
};
